const APP_PATHS = {
    DASHBOARD: '/',
    LOGIN: '/login',
    LOGIN_CALLBACK: '/login/callback',
    ADD_PERSONA: '/new_persona',
    LINKIFY: '/interest_builder',
    INTERESTS_TABLE: '/interests',
    PREFERENCES: '/settings',
    PERSONA_EXPLORER: '/persona_explorer',
    MIX_PERSONA: '/mix_persona',
    COMBINE_DASHBOARD: '/combine_dashboard',
    INTEREST_OVERLAP: '/interest_overlap',
    DUPLICATE_PERSONA: '/duplicate_persona/:id',
    USER_MANAGEMENT: '/user_management',
    USER_MANAGEMENT_ADD: '/user_management/add',
    USER_MANAGEMENT_CHANGE: '/user_management/change/:email/:role',
    LOOKALIKE_MODEL: '/lookalike_targeting',
    LOOKALIKE_MODEL_CREATE: '/lookalike_targeting/create',
    LOOKALIKE_MODEL_DETAIL: '/lookalike_targeting/detail/:id'
};
export { APP_PATHS };
